(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .component('sc3ClubContact', {            
            templateUrl: 'app/club-admin/club-contact/club-contact.component.html',
            controller: ClubContactComponent,
            bindings: {
                clubId: '<',
                contacts: '<'                
            }
        });

    var copy = angular.copy,
        noop = angular.noop;
   
    ClubContactComponent.$inject = ['Club', 'alert', 'confirm', 'gender', 'cultureName', 'clubContact', 'clubAdminResources'];
    function ClubContactComponent(Club, alert, confirm, gender, cultureName, clubContact, resources) {
        var ctrl = this;

        ctrl.insert = insert;
        ctrl.edit = edit;
        ctrl.save = save;
        ctrl.remove = remove;
        ctrl.cancel = cancel;
        ctrl.verify = verify;
        ctrl.verifyAll = verifyAll;

        ctrl.clubId = null;

        ctrl.types = Object.keys(clubContact.$metadata);
        ctrl.genderList = [gender.Male, gender.Female];
        ctrl.cultureList = [cultureName.en_CA, cultureName.fr_CA];
        ////////////////////////////////////////

        function insert() {
            var contact = { clubId: ctrl.clubId };
            ctrl.contacts.push(contact);
            edit(contact);
        }

        function edit(contact) {
            contact.$clone = angular.copy(contact);
        }

        function save(contact, form) {
            var clone = contact.$clone;
            if (form.$valid)
                Club.saveClubContact({ id: ctrl.clubId }, contact, success, error, true);

            function success(data) {
                copy(data, contact);
                delete contact.$clone;
            }

            function error() {
                alert.error(resources.saveContactFailed);
            }
        }

        function remove(contact) {
            confirm(resources.confirmDeleteContact).then(remove, noop);

            function remove() {
                Club.deleteClubContact({ id: ctrl.clubId }, contact, success, error, true);

                function success() {
                    removeFromArray(contact);
                }

                function error() {
                    alert.error(resources.deleteContactFailed);
                }
            }
        }

        function verify(contact) {
            confirm(resources.confirmVerifyContact).then(verify, noop);

            function verify() {
                Club.verifyClubContact({ id: ctrl.clubId }, contact, success, error, true);
            }

            function success(data) {                
                copy(data, contact);
            }

            function error() {
                alert.error(resources.verifyContactFailed);
            }
            
        }


        function verifyAll() {
            confirm(resources.confirmVerifyAllContacts).then(verifyAll, noop);

            function verifyAll() {
                Club.verifyAllClubContacts({ id: ctrl.clubId }, success, error, true);
            }

            function success() {

                getData(ctrl.clubId );

            }

            function error() {
                alert.error(resources.verifyAllContactsFailed);
            }

        }

        function getData(clubId) {
            return Club.getClubContacts({ id: clubId }, success, error);

            function success(data) {
                ctrl.contacts = data;
            }

            function error() {
           }
        }


        function cancel(contact) {
            delete contact.$clone;   
            if (!contact.id) {
                removeFromArray(contact);
            }
            
        }

        function removeFromArray(contact) {
            var index = ctrl.contacts.indexOf(contact);
            if (index !== -1)
                ctrl.contacts.splice(index, 1);
        }
    }
})();